module.exports = __webpack_public_path__ + "static/media/team.6837400c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/team.svg
// module id = 527
// module chunks = 0